import { Badge, Button, Container, Form, FormField, Grid, Input, Link, Modal, RadioGroup, Textarea, TokenGroup } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, buildBreadcrumbItems, fileToBase64, formatBytes, getAccountPlan, getCookie, getUrlVersion, setData } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import CurrencyInput from '../../../../../components/CurrencyInput';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import SelectAccountPlan from '../../../../../components/selects/selectAccountPlans';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

const pageSize = 20;

export const AdminProcessesChargesPage = () => {
    type ItemIds = {
        label: string;
        dismissaLabel: string;
        idUser: number;
    }
    type User = {
        idUser: number;
        displayName: string;
        idUserStatus: number;
        status: string;
        RUT: string;
        phone1: string;
        email: string;
    };
    type ItemCharge = {
        ammount: number;
        accountPlan: string;
        idAccountPlan: number;
        data: string;
        obs: string;
        dateTransaction: string;

    }
    type ItemInstallments = {
        amount: number;
        installments: number;
        accountPlan: string;
        idAccountPlan: number;
        currency: string;
        data: string;
        obs: string;
        idUsers: number[];
        day: number;

    }

    type ItemAccountPlan = {
        idAccountPlan: number;
        accountPlan: string;
        value: string;
        label: string;
    };
    const { data, menu, parameters } = useGlobalState();

    const [pac, setPac] = useState<any>();
    const [accountPlan, setAccountPlan] = useState<ItemAccountPlan>();
    const [accountPlans, setAccountPlans] = useState<ItemAccountPlan[]>([]);
    //const storeAdmin = useStoreAdmin();

    const [keyw, setKeyw] = useState("");


    const [progress, setProgress] = useState(0);
    const [charge, setCharge] = useState<ItemCharge>({
        ammount: 0,
        accountPlan: '',
        idAccountPlan: 0,
        data: '',
        obs: '',
        dateTransaction: '',
    });

    const [installment, setInstallment] = useState<ItemInstallments>({
        amount: 0,
        accountPlan: '',
        idAccountPlan: 0,
        data: '',
        obs: '',
        currency: '',
        installments: 1,
        idUsers: [],
        day: 1,
    });


    const [additionalInfo, setAdditionalInfo] = useState("");
    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);
    const [modalDatePickerOpen, setModalDatePickerOpen] = useState(false);
    const [showModalCharge, setShowModalCharge] = useState(false);
    const [showModalInstallments, setShowModalInstallments] = useState(false);
    const [installmentIsValid, setInstallmentIsValid] = useState(false);
    const [movementeType, setMovementeType] = useState("")
    const [loadingCSV, setLoadingCSV] = useState(false);
    const [loadingXLS, setLoadingXLS] = useState(false);
    const [loadingUpdate, setLoading] = useState(false);
    const [day, setDay] = useState(1);

    const [idCharges, setIdCharges] = useState<string>('');
    const [idInstallments, setIdInstallments] = useState<string>('');
    const [idUsersCharges, setIdUsersCharges] = useState<ItemIds[]>([]);
    const [idUsersInstallments, setIdUsersInstallments] = useState<ItemIds[]>([]);



    const [month, setMonth] = useState("");

    useEffect(() => {
        if (data) {
            const mappedAccountPlans: ItemAccountPlan[] = data.accountPlans.map((plan: ItemAccountPlan) => ({
                idAccountPlan: plan.idAccountPlan,
                accountPlan: plan.accountPlan,
                value: plan.idAccountPlan.toString(),
                label: plan.accountPlan
            }));
            setAccountPlans(mappedAccountPlans);
        }
    }, []);
    useEffect(() => {
        let isInvalid = false;
        if (installment.idAccountPlan === 0) isInvalid = true;
        if (idUsersInstallments.length === 0) isInvalid = true;
        if (installment.amount === 0) isInvalid = true;
        if (installment.data === "") isInvalid = true;
        setInstallmentIsValid(isInvalid)
    }, [installment]);

    useEffect(() => {
        const result = idCharges.replace(".", "").toUpperCase().split(/[^0-9kK-]+/);
        const matchedItems: ItemIds[] = data.users
            .filter((user: { idUser: { toString: () => string; }; RUT: string; }) => result.includes(user.idUser.toString()) || result.includes(user.RUT))
            .map((user: { displayName: any; idUser: any; }) => ({
                label: user.displayName,
                idUser: user.idUser
            }));
        setIdUsersCharges(matchedItems)

    }, [idCharges]);
    useEffect(() => {
        const result = idInstallments.replace(".", "").toUpperCase().split(/[^0-9kK-]+/);
        const matchedItems: ItemIds[] = data.users
            .filter((user: { idUser: { toString: () => string; }; RUT: string; }) => result.includes(user.idUser.toString()) || result.includes(user.RUT))
            .map((user: { displayName: any; idUser: any; }) => ({
                label: user.displayName,
                idUser: user.idUser
            }));
        setIdUsersInstallments(matchedItems)

    }, [idInstallments]);


    useEffect(() => {

    }, [idUsersInstallments, idUsersCharges]);


    const handleAddIntallments = async () => {
        try {
            setLoading(true)
            installment.idUsers = idUsersInstallments.map(u => u.idUser);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/installments/add',
                    'JWT': getCookie("JWT"),
                },

                body: JSON.stringify(installment),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                setShowModalInstallments(false);
                setIdInstallments("");
                addNotification(data.status, "success", setData)
            } else {
                addNotification(data.status, "error", setData)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handleDownloadSoftland = async (type: string) => {
        try {
            setLoading(true)
            if (type == "XLS")
                setLoadingXLS(true)
            if (type == "CSV")
                setLoadingCSV(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/processes/softland',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify({
                    month: parameters.period.split("-")[1],
                    year: parameters.period.split("-")[0],
                    type: type
                }),
            });

            if (!response.ok || !response.body) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            setProgress(0)
            const contentLength = response.headers.get('Content-Length');
            const total = contentLength ? parseInt(contentLength, 10) : 0;
            let loaded = 0;

            const reader = response.body.getReader();
            const chunks: BlobPart[] = [];

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                if (value) {
                    chunks.push(value); // ✅ now valid
                    loaded += value.length;

                    if (total) {
                        const percent = Math.round((loaded / total) * 100);
                        setProgress(percent);
                        setAdditionalInfo(`${formatBytes(loaded)} / ${formatBytes(total)}`);
                    }
                }
            }

            const blob = new Blob(chunks);
            setProgress(0)
            setLoadingXLS(false)
            setLoadingCSV(false)
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `SOFTLAND-${parameters.period.replace("/", ".")}.${type == "XLS" ? "xls" : "csv"}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const [pacUniverse, setPacUniverse] = React.useState<File[]>([]);
    const [pacCharges, setPacCharges] = React.useState<File[]>([]);
    const [pacDate, setPacDate] = React.useState('');

    const handleUniverseLoadChange = async (files: File[]) => {
        try {
            // Use Promise.all to concurrently convert all files to Base64
            const base64Results = await Promise.all(files.map(fileToBase64));

            // Map the results back to an array of objects that include the Base64 data hjjhg 
            const attachmentsWithBase64 = base64Results.map(result => ({
                name: result.file.name,
                content: result.base64,
                size: result.file.size,
            }));
            console.log(attachmentsWithBase64[0]);
            handlePACUploadUniverse(attachmentsWithBase64[0]);


        } catch (error) {
            console.error('Error reading files:', error);
        }
    };


    const handlePACUploadUniverse = async (f: any) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/pac/universe',
                    'JWT': getCookie("JWT"),
                },

                body: JSON.stringify(f),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                addNotification(data.status, "success", setData)
            } else {
                addNotification(data.status, "error", setData)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const isButtonDisabled = React.useMemo(() => {
        return (
            movementeType === "" ||
            charge.idAccountPlan === 0 ||
            charge.ammount === 0 ||
            charge.data.length < 10 ||
            idUsersCharges.length === 0
        );
    }, [movementeType, charge, idUsersCharges]);
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => {
                setSideOpen(detail.open)
            }}

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="m">

                        <Header
                            actions={<Favorites />}

                        //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >Procesos de usuario



                        </Header>

                        <Container header={<Header>Movimientos masivos</Header>}>
                            <Form actions={<Button variant='primary' disabled={idUsersCharges.length === 0 || movementeType === ""} onClick={() => setShowModalCharge(true)}>Siguiente</Button>}>
                                Efectuar cargos o abonos a múltiples usuarios
                                <SpaceBetween direction="vertical" size="xs">
                                    <RadioGroup
                                        onChange={({ detail }) => setMovementeType(detail.value)}
                                        value={movementeType}
                                        direction="horizontal"
                                        items={[
                                            { value: "charge", label: "Cargo" },
                                            { value: "debit", label: "Abono" },
                                        ]}
                                    />

                                    <FormField
                                        label={'Identificación de usuarios'}
                                        info={idUsersCharges.length === 0 ? null : <Link onClick={() => setIdCharges("")}>Limpiar</Link>}
                                        constraintText={movementeType === "" ? "Seleccione un tipo de movimiento para habilitar el ingreso de RUTs o ID de usuarios" : "Al pegar los nuevos elementos se generará un listado de usuarios seleccionados"}
                                    >
                                        <Textarea
                                            readOnly={movementeType === ""}

                                            onChange={({ detail }) => {
                                                setIdCharges(detail.value.replace(".", "").toUpperCase().split(/[^0-9kK-]+/).join(" "));
                                            }}
                                            value={idCharges}
                                            placeholder="Pegar RUTs o ID de usuarios"
                                        />

                                    </FormField>
                                    <TokenGroup
                                        readOnly
                                        onDismiss={({ detail: { itemIndex } }) => {
                                            return
                                        }}
                                        items={idUsersCharges}
                                        limit={3}
                                    />
                                </SpaceBetween>
                            </Form>
                        </Container>



                    </SpaceBetween>

                    <Modal visible={showModalCharge}
                        header={<Header variant='h2' actions={
                            <Badge color={movementeType === "charge" ? "red" : "blue"}>{movementeType === "charge" ? "Cargo" : "Abono"}</Badge>
                        }>
                            Detalle de movimiento masivo
                        </Header>
                        } size="medium" footer={
                            <Box>
                                <Box float='left'><Button variant="link" onClick={() => setShowModalCharge(false)}>Cancelar</Button></Box>
                                <Box float='right'><Button variant='primary' disabled={isButtonDisabled}>Generar</Button></Box>
                            </Box>
                        } onDismiss={() => setShowModalCharge(false)}>
                        <Grid gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}>
                            <div>
                                <FormField label={"Destinatarios"}>
                                    <Input readOnly value={`${idUsersCharges.length} usuario${idUsersCharges.length === 1 ? "" : "s"}`} />
                                </FormField>
                            </div>
                            <div onClick={() => setModalDatePickerOpen(true)}>
                                <FormField label={"Fecha contable"}>
                                    <DPModal date={charge?.dateTransaction.toString()}
                                        today
                                        onConfirm={(date) => {
                                            setCharge({ ...charge, dateTransaction: date });
                                        }}
                                    />
                                </FormField>
                            </div>
                        </Grid>
                        <Grid gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}>
                            <div>
                                <FormField label={"Monto"}>
                                    <CurrencyInput value={charge?.ammount || 0}
                                        onChange={(value) => {
                                            if (!charge) return;
                                            setCharge({ ...charge, ammount: value });
                                        }}
                                    />
                                </FormField>
                            </div>
                            <div>
                                <FormField label={"Cuenta"}>
                                    <SelectAccountPlan single value={accountPlan?.idAccountPlan ?? 0} onSelect={(idAccountPlan: number) => {
                                        setAccountPlan({
                                            idAccountPlan: idAccountPlan,
                                            accountPlan: getAccountPlan(idAccountPlan, data).accountPlan,
                                            value: idAccountPlan.toString() ?? "",
                                            label: getAccountPlan(idAccountPlan, data).accountPlan ?? ""
                                        });

                                        setCharge({
                                            ...charge,
                                            idAccountPlan: idAccountPlan,
                                            accountPlan: getAccountPlan(idAccountPlan, data).accountPlan ?? ""
                                        });

                                    }} />
                                </FormField>
                            </div>
                        </Grid>
                        <Grid gridDefinition={[{ colspan: 12 }]}>
                            <div>
                                <FormField label={"Concepto"}>
                                    <Input value={charge?.data.toString() || ""}
                                        onChange={({ detail }) => {
                                            if (!charge) return;
                                            setCharge({ ...charge, data: detail.value });
                                        }} />
                                </FormField>
                            </div>
                        </Grid>
                        <Grid gridDefinition={[{ colspan: 12 }]}>
                            <div>
                                <FormField label={"Observaciones"} constraintText={"Opcional"}>
                                    <Input value={charge?.obs.toString() || ""}
                                        onChange={({ detail }) => {
                                            if (!charge) return;
                                            setCharge({ ...charge, obs: detail.value });
                                        }} />
                                </FormField>
                            </div>
                        </Grid>

                    </Modal>


                </>
            }
        />
    );
};
